import { useState } from "react";
import { FaArrowUpLong } from "react-icons/fa6";
import ChatIcon from "../../../../../assets/images/bot-icon.png";

const ChatIntro = ({
  testInfo,
  onSendQuestion,
}: {
  testInfo: any;
  onSendQuestion?: (question: string) => void;
}) => {
  const allow_to_chat = testInfo?.allow_to_chat;
  const [question, setQuestion] = useState("");

  const handleSendQuestion = () => {
    if (question.trim() && onSendQuestion) {
      onSendQuestion(question);
      setQuestion("");
    }
  };

  const suggestions = [
    "وضعیت کلی سلامت من رو ارزیابی کن",
    "آزمایش من به طور کلی چه چیزی نشون می‌ده؟",
    "آیا علائم دیابت توی آزمایش من دیده می‌شه؟",
    "چقدر احتمال داره دچار کم‌کاری تیروئید باشم؟",
    "خواب روی نتیجه آزمایش من تاثیر داشته؟",
    "آیا لازمه با پزشک مشورت کنم؟",
  ];

  const handleSuggestionClick = (suggestion: string) => {
    setQuestion(suggestion);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendQuestion();
    }
  };

  return (
    <div className="h-full min-h-[55vh] p-5 border rounded-xl flex flex-col flex flex-col items-center justify-center">
      <img src={ChatIcon} className="w-20" alt="chat" />
      <h2 className="text-xl font-rokh font-[900] mt-5 text-center">بادی‌گپ</h2>
      <p className="text-sm lg:text-base font-rokh font-[700] text-center">
        سوالاتی که در مورد آزمایشت داری رو اینجا بپرس
      </p>

      {allow_to_chat ? (
        <>
          <div className="w-full max-w-lg mt-6 relative">
            <textarea
              rows={5}
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="سوالت رو اینجا بنویس"
              maxLength={200}
              className="bg-white w-full p-3 border rounded-lg resize-none text-right text-xs"
            />
            <button
              onClick={handleSendQuestion}
              disabled={!question.trim()}
              className={`${
                !question.trim()
                  ? "bg-gray-200 text-gray-500"
                  : "bg-blue-500 text-white"
              } absolute bottom-3 left-2 rounded-full p-2 hover:bg-blue-600 transition-colors`}
            >
              <FaArrowUpLong size={12} />
            </button>
          </div>

          <div className="max-w-[320px] lg:max-w-[510px] mt-2 flex justify-start gap-1 overflow-auto pb-1">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className="flex-1 bg-gray-100 text-gray-600 px-3 py-1 rounded-md text-xs hover:bg-gray-200 transition-colors whitespace-nowrap"
              >
                {suggestion}
              </button>
            ))}
          </div>
        </>
      ) : (
        <div>
          <p className="mt-10 text-sm lg:text-base text-center font-bold max-w-xs">
            توی حالت تحلیل پیشرفته آزمایش، می‌تونی با آزمایشت صحبت کنی و جواب
            سوالاتت رو بگیری.
          </p>
        </div>
      )}
    </div>
  );
};

export default ChatIntro;
